var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"success","title":"订单提交成功","sub-title":"自动跳转至订单下载页，请稍等......."},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-spin',{attrs:{"tip":"Loading..."}},[_c('div',{staticClass:"spin-content"})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }